<template>
  <div ref="chartDomRef" class="widget"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { debounce } from '@safety/shared-utils'
import * as echarts from 'echarts'

defineExpose({
  resize: () => {
    if (chart && !chart.isDisposed()) {
      chart.resize()
    }
  }
})
const props = defineProps({ title: String, data: Array })
const chartDomRef = ref(null)
let chart = null

const renderChart = debounce(function () {
  //为了提高性能,使用debounce,导致会延迟执行,此时chart实例可能已经被销毁
  if (!chart || chart.isDisposed()) return
  chart.setOption({
    title: {
      text: props.title,
      textStyle: {
        color: 'white',
        textShadowColor: 'rgba(255, 255, 255, 0.5)',
        textShadowBlur: 15
      },
      left: 'center',
      top: '5%'
    },
    legend: {
      bottom: '10px',
      left: 'center',
      textStyle: {
        color: 'rgb(99, 158, 216)'
      }
    },
    series: [
      {
        type: 'pie',
        radius: ['25%', '70%'],
        label: {
          show: false
        },
        data: props.data,
        itemStyle: {
          borderColor: 'rgba(0, 0, 0, 0.3)',
          borderWidth: 5,
          borderCap: 'round',
          borderRadius: 10,
          shadowColor: 'rgba(255, 255, 255, 0.5)',
          shadowBlur: 15
        }
      }
    ],
    textStyle: {
      color: 'rgb(99, 158, 216)'
    }
  })
}, 1000)

onMounted(() => {
  chart = echarts.init(chartDomRef.value, 'light')
  renderChart()
})

onUnmounted(() => {
  chart?.dispose()
})

watch([() => props.title, () => props.data], renderChart)
</script>

<style lang="scss" scoped>
.widget {
  width: 100%;
  height: 100%;
}
</style>
